/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Open Source Version is distributed with Sencha Ext JS pursuant to a FLOSS Exception agreed upon
 * between Sonatype, Inc. and Sencha Inc. Sencha Ext JS is licensed under GPL v3 and cannot be redistributed as part of a
 * closed source work.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import Axios from 'axios';
import {assign, Machine} from "xstate";

export const applicationHealthCheckUrl = '/service/rest/internal/ui/ahc';

export default Machine({
  id: 'analyzeApplicationMachine',
  initial: 'loading',

  states: {
    loading: {
      invoke: {
        src: 'fetchData',
        onDone: {
          target: 'loaded',
          actions: ['setAccepted']
        }
      }
    },
    loaded: {
      on: {
        '': [
            {target: 'showEula', cond: 'shouldShowEula' },
            {target: 'showAnalyze'}
        ]
      }
    },
    showEula: {
      on: {
        EULA_ACCEPTED: {
          target: 'loading'
        },
        EULA_DECLINED: {
          actions: ['onClose']
        }
      }
    },
    showAnalyze: {
      on: {
        CANCEL: {
          actions: ['onClose']
        },
        ANALYZED: {
          actions: ['onClose']
        }
      }
    }
  },
  on: {
    RETRY: {
      target: 'loading'
    }
  }
}, {
  guards: {
    shouldShowEula: context => context.pristineData.tosAccepted === false
  },
  actions: {
    setAccepted: assign({
      pristineData: (_, event) => event.data?.data
    })
  },
  services: {
    fetchData: ({componentModel}) => Axios.get(applicationHealthCheckUrl, {params: {component: componentModel}})
  }
});
